// styles.js
import styled from "styled-components";

export const AppContainer = styled.div`
  position: relative;
  height: 100vh;
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  font-family: sans-serif;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  background-color: #0a0a0acc;
`;
export const AppContainer2 = styled.div`
  height: 100vh;
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  font-family: sans-serif;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  background-color: #0a0a0acc;
`;
export const MapBackground = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FloatingButton = styled.button`
  position: absolute;
  top: 12px;
  left: 16px;
  background: white;
  padding: 12px;
  border-radius: 50%;
  border: none;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  z-index: 10;
`;

export const TopSheet = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  border-radius: 0 0 12px 12px;
  padding: 12px;
  box-sizing: border-box;
  box-shadow: 0 -10px 25px rgba(0, 0, 0, 0.05);
`;


export const BottomBox = styled.div`
  width: 100%;
  border-radius: 12px 12px 0 0;
  padding: 12px;
  box-sizing: border-box;
  box-shadow: 0 -10px 25px rgba(0, 0, 0, 0.05);
`;

export const BottomSheet = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  border-radius: 12px 12px 0 0;
  padding: 12px;
  box-sizing: border-box;
  box-shadow: 0 -10px 25px rgba(0, 0, 0, 0.05);
`;
export const CenterSheet = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
export const CenteTopSheet = styled.div`
  position: absolute;
  top: 10%;
  left: 50%;
  width: 90%;

  transform: translate(-50%, 0%);
`;

export const DetailLittleBox = styled.div`
  border-radius: 5px;
  padding: 5px;
  border: 1px solid #38383a;
  margin-bottom: 2px;
  margin-top: 2px;
  box-sizing: border-box;
  box-shadow: 0 -10px 25px rgba(0, 0, 0, 0.05);
  background-color: #38383a;
`;

export const DetailInlineBox = styled.div`
  border-radius: 5px;
  flex-direction: row;
  display: flex;
  border: 1px solid #38383a;
  margin-bottom: 2px;
  margin-top: 2px;
  background-color: #38383a;
`;
export const DetailInlineBoxItem = styled.div`
  flex: 1;
  align-items: center;
  flex-direction: column;
  display: flex;
  justify-content: center;
`;

export const DetailBoxClean = styled.div`
  padding: 12px;
`;

export const DetailBox = styled.div`
  border-radius: 12px;
  padding: 12px;
  border: 1px solid #38383a;
  box-sizing: border-box;
  box-shadow: 0 -10px 25px rgba(0, 0, 0, 0.05);
  background-color: #38383a;
`;

export const DetailLargeBox = styled.div`
  border-radius: 12px;
  width: 100%;

  padding: 12px;
  border: 1px solid #38383a;
  box-sizing: border-box;
  box-shadow: 0 -10px 25px rgba(0, 0, 0, 0.05);
  background-color: #38383a;
`;

export const DragHandle = styled.div`
  width: 48px;
  height: 6px;
  background-color: #f1f5f9;
  border-radius: 3px;
  margin: 0 auto 12px;
`;

export const DestaquePlus = styled.p`
  color: #ffffff;
  font-size: 30px;
  font-weight: bold;
  margin-bottom: 6px;
`;

export const Destaque = styled.p`
  color: #ffffff;
  font-size: 24px;
  font-weight: bold;
`;

export const Texto1 = styled.p`
  color: #888888;
  font-size: 18px;
  font-weight: bold;
`;
export const Texto2 = styled.span`
  color: #888888;
  font-size: 14px;
  font-weight: bold;
`;

export const Texto3 = styled.span`
  color: #fff;
  font-size: 18px;
  font-weight: bold;
`;

export const Texto4 = styled.span`
  color: #f77317;
  font-size: 18px;
  font-weight: bold;
`;
export const DestaqueTopo = styled.p`
  color: #ffffff;
  font-size: 24px;
  font-weight: bold;
`;
export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
  align-items: left;
  justify-content: left;

  span {
    font-size: 18px;
    text-transform: uppercase;
    font-weight: bold;
    color: #4f4f4f;
    margin: 0px;
    text-align: left;
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 8px;
  background: #4f4f4f;
  border-radius: 12px;
  border: 1px solid #4f4f4f;
  font-size: 40px;

  input {
    border: none;
    color: #fff;
    background: transparent;
    width: 100%;
    outline: none;
    padding: 10px;
    font-size: 18px;
  }
`;

export const Dot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${(props) => props.color || "#F77317"};
`;

export const BoxTipo = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 8px;
  background-color: ${(props) => props.color || "#F77317"};
  align-items: center;
  justify-content: center;
  display: flex;
`;

export const VehicleList = styled.div`
  display: flex;
  gap: 8px;
  overflow-x: auto;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: space-between;
  padding: 0;
  margin-bottom: 12px;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const VehicleCard = styled.div`
  border-radius: 16px;

  padding: 0;
  border: 2px solid ${(props) => (props.selected ? "#000" : "#EA6C0A")};
  background: ${(props) => (props.selected ? "#f8fafc" : "#38383a")};
  text-align: center;
  align-items: center;
  cursor: pointer;
  flex: 1;
  display: flex;
  flex-direction: row;
`;

export const VehicleCardItem = styled.div`
  padding: 10px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
export const VehicleCardItemG = styled.div`
  flex: 2;
  display: flex;

  padding: 0;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  flex-grow: 1;
`;
export const LinhaCards = styled.div`
  padding: 0;
  flex: 1;
  display: flex;
  flex-direction: row;
`;

export const LinhaCardsItemp = styled.div`
  flex-direction: column;
  align-items: start;
  justify-content: flex-start;
  flex-shrink: 1;
`;

export const LinhaCardsItem = styled.div`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
`;
export const PagamentoCard = styled.div`
  border-radius: 16px;

  padding: 0;
  text-align: center;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex: 1;
  display: flex;
  flex-direction: row;
`;

export const PagamentoCardItem = styled.div`
  padding: 10px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const PrimaryButton = styled.button`
  width: 100%;
  padding: 18px;
  margin: 5px;
  text-transform: uppercase;
  font-size: 18px;
  background-color: ${(props) => (props.variant === "disabled" ? "#dedede" : props.variant === "danger" ? "#fef2f2" : props.secondary === "true" ? "#444" : "#F77317")};
  color: ${(props) => (props.variant === "disabled" ? "#4a4a4a" : props.variant === "danger" ? "#dc2626" : props.secondary === "true"  ? "#fff" : "#fff")};
  border-radius: 16px;
  font-weight: bold;
  border: none;
  cursor: pointer;
  transition: transform 0.1s;
  border: ${(props) => (props.secondary ? "1px solid #EA6C0A" : "none")};
  &:active {
    transform: scale(0.97);
  }
`;

export const PrimaryButtonLittle = styled.button`
  padding: 18px;
  margin: 5px;
  text-transform: uppercase;
  font-size: 18px;
  background-color: ${(props) => (props.variant === "disabled" ? "#dedede" : props.variant === "danger" ? "#fef2f2" : props.secondary === "true" ? "#444" : "#F77317")};
  color: ${(props) => (props.variant === "disabled" ? "#4a4a4a" : props.variant === "danger" ? "#dc2626" : props.secondary === "true"  ? "#fff" : "#fff")};
  border-radius: 16px;
  font-weight: bold;
  border: none;
  cursor: pointer;
  transition: transform 0.1s;
  border: ${(props) => (props.secondary ? "1px solid #EA6C0A" : "none")};
  &:active {
    transform: scale(0.97);
  }
`;

export const DriverCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background: #f8fafc;
  border-radius: 16px;
  margin-bottom: 12px;
`;
export const AddressTimeline = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 4px;
`;

export const TimelineItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;

  /* A linha vertical conectando os pontos */
  &:not(:last-child)::after {
    content: "";
    position: absolute;
    left: 4px; /* Centro do Dot de 8px */
    top: 12px;
    bottom: -20px;
    width: 1px;
    border-left: 1px dashed #cbd5e1;
  }

  span {
    font-size: 18px;
    color: #fff;
  }
`;

export const AddressInfo = styled.div`
  display: flex;
  flex-direction: column;

  label {
    font-size: 10px;
    text-transform: uppercase;
    color: #94a3b8;
    letter-spacing: 0.05em;
  }

  span {
    font-size: 14px;
    color: #1e293b;
    font-weight: 500;
  }
`;

export const MotoristaBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  padding: 5px;
  margin: 10px;
  gap: 5px;
`;
export const MotoristaLinha = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: #666;
  padding: 4px;
  gap: 25px;
  border-radius: 4px;
`;
export const MotoristaNome = styled.div`
  font-size: 20px;
  color: #ffffff;
  font-weight: 750;
`;

export const MotoristaCarro = styled.div`
  font-size: 18px;
  color: #ffffff;
  font-weight: 500;
`;

export const MotoristaPlaca = styled.div`
  font-size: 14px;
  padding: 4px;
  border-radius: 4px;
  text-transform: uppercase;
  color: #ffffff;
  background: #888888;
  font-weight: 500;
  white-space: nowrap;
  flex-overflow: nowrap;
`;


export const StatusCorrida = styled.div`
  font-size: 18px;
  color: #ffffff;
  font-weight: 500;
`;
export const StatusCorridaItem = styled.div`
  font-size: 18px;
  color: #ffffff;
  font-weight: 500;
  span {
    color: #F77317;
  font-weight: 750;
}
`;
export const Compartilhe = styled.div`
  font-size: 18px;
  color: #ffffff;
  background: #F77317;
  font-weight: 750;
  padding: 10px;
  border-radius: 8px;
  display: flex;
  align-items: center;
}
`;